import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
import * as ForgotPassword from '../actions/forgot-password';
import { LOAD_STATES } from './common';
import { formErrors } from '../stubs/form-errors';

const reducer = createReducer(InitialState.forgotPassword, builder => {
  builder.addCase(UIActions.logout.type, () => ({ ...InitialState.forgotPassword }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.forgotPassword }));

  builder.addCase(ForgotPassword.handleForgotPassword.pending, state => ({
    ...state,
    loadState: LOAD_STATES.started,
    formErrors: formErrors.noErrors
  }));

  builder.addCase(ForgotPassword.handleForgotPassword.rejected, (state, action) => ({
    ...state,
    loadState: LOAD_STATES.failed,
    formErrors: (action.payload as any)?.errors ?? formErrors.noErrors
  }));

  builder.addCase(ForgotPassword.handleForgotPassword.fulfilled, state => ({
    ...state,
    loadState: LOAD_STATES.done
  }));

  builder.addCase(ForgotPassword.reduxSavePasswordDto, (state, action) => ({
    ...state,
    passwordResetDto: action.payload
  }));

  builder.addCase(ForgotPassword.submitNewPassword.pending, state => ({
    ...state,
    loadState: LOAD_STATES.started
  }));

  builder.addCase(ForgotPassword.submitNewPassword.rejected, (state, action) => ({
    ...state,
    formErrors: (action.payload as any) ?? formErrors.noErrors,
    loadState: LOAD_STATES.failed
  }));

  builder.addCase(ForgotPassword.submitNewPassword.fulfilled, (state, action) => ({
    ...action.payload,
    ...state,
    loadState: LOAD_STATES.done
  }));

  builder.addCase(ForgotPassword.initializeForgotPassword, state => ({
    ...state,
    loadState: LOAD_STATES.initial,
    formErrors: formErrors.noErrors
  }));
});

export default reducer;
